import React from 'react'
import Routing from './components/Routing'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-109326169-15');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  return <Routing />
}

export default App
